import React from 'react';
import { invert } from './utils';
import { SecondaryLine, TotalLine } from './Lines';
import MathBoxGroup from './MathBoxGroup';

const PackageGroup = ({ pricing }) => {
  const { opdTotal, totalMsrpBeforeOpd, isSeeDealer } = pricing;

  if (isSeeDealer || !opdTotal) {
    return null;
  }

  return (
    <MathBoxGroup ruled>
      <TotalLine labelKey="total.before.opd" value={totalMsrpBeforeOpd} />
      <SecondaryLine labelKey="package.discount" value={invert(opdTotal)} />
    </MathBoxGroup>
  );
};

export default PackageGroup;
